import { render, staticRenderFns } from "./ClientProfileOrders.vue?vue&type=template&id=5a776d51"
import script from "./ClientProfileOrders.vue?vue&type=script&lang=js"
export * from "./ClientProfileOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports